<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p><a id="toc">
<div class="fmh1">
    Table of Contents
  </div>
<div>
     <br/>
</div>
</a><div class="cfmh"><a id="toc">
</a><span href="#/Text/andr_9781569759516_oeb_tp_r1" title="Link target outside of Sample">Title Page</span>
</div>
<div class="cfmh">
<a href="#/Text/andr_9781569759516_oeb_ack_r1">Acknowledgements</a>
</div>
<div class="cfmh">
<a href="#/Text/andr_9781569759516_oeb_itr_r1">Introduction</a>
</div>
<div>
     <br/>
</div>
<div class="cct">
<a href="#/Text/andr_9781569759516_oeb_c01_r1">CHAPTER 1 - SNACKS &amp; NIBBLES</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h1">STUFFED MUSHROOMS</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h2">FRIED CHICKPEAS</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h3">OLIVE FOCACCIA</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h4">TABOULI-STUFFED MINI PITAS</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h5">GUACAMOLE WITH TOMATILLOS</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h6">BRATWURSTS IN A BLANKET</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h7">JALAPEÑO CHEESE–STUFFED PEPPERS</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h8">THAI RED CURRY DEVILED EGGS</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h9">SPICY BONELESS CHICKEN PIECES</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h10">SLOPPY JOE NACHOS</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h11">PINWHEELS with SPINACH and PROSCIUTTO</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h12">PORK BUNS with BROCCOLI SLAW</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h13">FRITO PIE</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h14">MINI TOSTADAS with BEEF BRISKET</a>
</div>
<div class="ch1">
<a href="#/Text/andr_9781569759516_oeb_c01_r1#h15">SWEET CHILI WINGS</a>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/andr_9781569759516_oeb_c02_r1" title="Link target outside of Sample">CHAPTER 2 - SANDWICHES &amp; SALADS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h1" title="Link target outside of Sample">GRILLED FOUR-CHEESE SANDWICHES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h2" title="Link target outside of Sample">ALMOND BUTTER and BANANA SANDWICHES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h3" title="Link target outside of Sample">FRENCH TOAST and SAUSAGE SANDWICHES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h4" title="Link target outside of Sample">GRILLED CHICKEN STRIPS on NAAN with RED PEPPER SPREAD</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h5" title="Link target outside of Sample">MUFFULETTA SANDWICHES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h6" title="Link target outside of Sample">TUNA SALAD SANDWICHES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h7" title="Link target outside of Sample">FRIED FISH SANDWICHES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h8" title="Link target outside of Sample">BUFFALO CHICKEN WRAPS with BLUE CHEESE and CARROTS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h9" title="Link target outside of Sample">EGG SALAD SANDWICHES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h10" title="Link target outside of Sample">PULLED PORK SANDWICHES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h11" title="Link target outside of Sample">BLT SANDWICHES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h12" title="Link target outside of Sample">CHILEAN-STYLE HOT DOGS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h13" title="Link target outside of Sample">MEATBALL SUB</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h14" title="Link target outside of Sample">TROPICAL FRUIT SALAD</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h15" title="Link target outside of Sample">CAESAR SALAD 2.0</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h16" title="Link target outside of Sample">BARBECUE SALAD with RANCH DRESSING</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h17" title="Link target outside of Sample">CHICKEN SALAD-STUFFED TOMATOES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h18" title="Link target outside of Sample">ANTIPASTO SALAD</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c02_r1#h19" title="Link target outside of Sample">GREEK PASTA SALAD</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/andr_9781569759516_oeb_c03_r1" title="Link target outside of Sample">CHAPTER 3 - SOUPS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h1" title="Link target outside of Sample">MISO SOUP with TOFU and SPINACH</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h2" title="Link target outside of Sample">PESTO TORTELLINI SOUP</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h3" title="Link target outside of Sample">THAI CARROT SOUP</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h4" title="Link target outside of Sample">RICE and BEANS SOUP</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h5" title="Link target outside of Sample">DOUBLE BUTTERNUT SQUASH SOUP with GORGONZOLA RAVIOLI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h6" title="Link target outside of Sample">CURRIED LENTIL SOUP</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h7" title="Link target outside of Sample">SEAFOOD STEW with GARLIC BREAD CROUTONS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h8" title="Link target outside of Sample">MEXICAN TORTILLA SOUP with AVOCADO and TORTILLA CHIPS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h9" title="Link target outside of Sample">CHICKEN and DUMPLINGS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h10" title="Link target outside of Sample">ANDOUILLE and CHICKPEA SOUP</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h11" title="Link target outside of Sample">EGG DROP SOUP with CILANTRO-CHICKEN WONTONS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h12" title="Link target outside of Sample">TURKEY and VEGETABLE CHILI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h13" title="Link target outside of Sample">BEEF UDON SOUP</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h14" title="Link target outside of Sample">LOADED POTATO SOUP</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h15" title="Link target outside of Sample">TOMATO-MEATBALL SOUP with CHEESE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c03_r1#h16" title="Link target outside of Sample">GAZPACHO</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/andr_9781569759516_oeb_c04_r1" title="Link target outside of Sample">CHAPTER 4 - PASTAS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h1" title="Link target outside of Sample">OLIVE OIL SPAGHETTI with ARUGULA</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h2" title="Link target outside of Sample">CHICKPEA PENNE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h3" title="Link target outside of Sample">EGGPLANT PARMESAN SPAGHETTI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h4" title="Link target outside of Sample">EGGPLANT AND GARLIC CAPELLINI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h5" title="Link target outside of Sample">PORTABELLA MUSHROOM RAVIOLI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h6" title="Link target outside of Sample">FARFALLE with VODKA SAUCE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h7" title="Link target outside of Sample">SPAGHETTI PUTTANESCA</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h8" title="Link target outside of Sample">CAPELLINI with SMOKED SARDINES GARLIC and PINE NUTS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h9" title="Link target outside of Sample">SEAFOOD FETTUCCINI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h10" title="Link target outside of Sample">SPINACH ALFREDO LINGUINE with CHICKEN</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h11" title="Link target outside of Sample">SPAGHETTI and MEATBALLS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h12" title="Link target outside of Sample">ROTELLE with PESTO, PEAS, and PROSCIUTTO</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c04_r1#h13" title="Link target outside of Sample">SPAGHETTI with CHICKEN SAUSAGE and TOMATO SAUCE</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/andr_9781569759516_oeb_c05_r1" title="Link target outside of Sample">CHAPTER 5 - MAIN MEALS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h1" title="Link target outside of Sample">FISH TACOS with MANGO SALSA</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h2" title="Link target outside of Sample">CHICKEN in TOMATILLO SAUCE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h3" title="Link target outside of Sample">TUNA CASSEROLE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h4" title="Link target outside of Sample">CHICKEN MASALA with SWEET POTATOES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h5" title="Link target outside of Sample">GARLIC BUTTER SHRIMP with QUINOA</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h6" title="Link target outside of Sample">CHICKEN and CHEESE ENCHILADAS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h7" title="Link target outside of Sample">MEDITERRANEAN CHICKEN with FETA CHEESE and SUN DRIED TOMATOES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h8" title="Link target outside of Sample">PORK CHOPS in CREAMY SPINACH SAUCE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h9" title="Link target outside of Sample">ASIAN MEATBALLS in PEANUT SAUCE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h10" title="Link target outside of Sample">SOYAKI STEAK</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h11" title="Link target outside of Sample">BEEF STROGANOFF WANNABE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h12" title="Link target outside of Sample">BACON CHEESEBURGER</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h13" title="Link target outside of Sample">SLOPPY JOES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h14" title="Link target outside of Sample">TOSTADAS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c05_r1#h15" title="Link target outside of Sample">MEAT LOAF MUFFINS</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/andr_9781569759516_oeb_c06_r1" title="Link target outside of Sample">CHAPTER 6 - VEGETARIAN MAIN MEALS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c06_r1#h1" title="Link target outside of Sample">TAQUITO CASSEROLE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c06_r1#h2" title="Link target outside of Sample">TERIYAKI TOFU with BABY BROCCOLI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c06_r1#h3" title="Link target outside of Sample">TACO TIME</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c06_r1#h4" title="Link target outside of Sample">CURRIED CAULIFLOWER</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c06_r1#h5" title="Link target outside of Sample">STUFFED BAKED POTATOES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c06_r1#h6" title="Link target outside of Sample">BRIE and BUTTERNUT SQUASH QUESADILLAS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c06_r1#h7" title="Link target outside of Sample">ZUCCHINI and POLENTA BAKE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c06_r1#h8" title="Link target outside of Sample">RICE and BLACK BEANS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c06_r1#h9" title="Link target outside of Sample">OLIVE. RED PEPPER, and ARUGULA PIZZA</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c06_r1#h10" title="Link target outside of Sample">VEGETABLE FRIED RICE</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/andr_9781569759516_oeb_c07_r1" title="Link target outside of Sample">CHAPTER 7 - MICROWAVE MAIN MEALS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h1" title="Link target outside of Sample">TAMALE-ENCHILADA CASSEROLE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h2" title="Link target outside of Sample">BLACK PEPPER SHRIMP with FRIED RICE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h3" title="Link target outside of Sample">VEGGIE RISOTTO with SHRIMP</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h4" title="Link target outside of Sample">CHICKEN PARMESAN STRIPS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h5" title="Link target outside of Sample">PAD THAI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h6" title="Link target outside of Sample">BEEF FAJITAS with GUACAMOLE and PICO DE GALLO</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h7" title="Link target outside of Sample">SPAGHETTI MEETS MAC and CHEESE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h8" title="Link target outside of Sample">CARNE ASADA POLENTA “LASAGNE”</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h9" title="Link target outside of Sample">STUFFED RED PEPPERS with CHICKEN and ORZO</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h10" title="Link target outside of Sample">PENNE MEATBALLS with ARRABIATA SAUCE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h11" title="Link target outside of Sample">TORTILLA CHILI CHEESE DOGS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c07_r1#h12" title="Link target outside of Sample">GREEN CHILE SHEPHERD’S PIE</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/andr_9781569759516_oeb_c08_r1" title="Link target outside of Sample">CHAPTER 8 - SIMPLE SIDES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h1" title="Link target outside of Sample">HEARTS of PALM with MANGO and ONION</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h2" title="Link target outside of Sample">ROASTED TOMATOES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h3" title="Link target outside of Sample">ASPARAGUS with AIOLI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h4" title="Link target outside of Sample">PARMESAN and BREAD CRUMB-CRUSTED TOMATOES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h5" title="Link target outside of Sample">BEETS with MINT GREMOLATA</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h6" title="Link target outside of Sample">SUGAR SNAP PEAS with BOK CHOY</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h7" title="Link target outside of Sample">BROCCOLI with DRIED CHERRIES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h8" title="Link target outside of Sample">MEXICAN CORN CORN on the COB</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h9" title="Link target outside of Sample">STUFFED PEAR HALVES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h10" title="Link target outside of Sample">PESTO-ROASTED POTATOES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h11" title="Link target outside of Sample">BAKED SWEET POTATO SPEARS with MEXICAN SPICES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h12" title="Link target outside of Sample">GREEN CHILE CORN BREAD MUFFINS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h13" title="Link target outside of Sample">GLAZED CARROTS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h14" title="Link target outside of Sample">RICE and VERMICELLI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c08_r1#h15" title="Link target outside of Sample">CURRIED COUSCOUS with APPLES</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/andr_9781569759516_oeb_c09_r1" title="Link target outside of Sample">CHAPTER 9 - QUICK &amp; HEARTY BRAIN FOOD FOR FINALS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h1" title="Link target outside of Sample">TROPICAL SMOOTHIE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h2" title="Link target outside of Sample">VERY BERRY SMOOTHIE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h3" title="Link target outside of Sample">OATMEAL with BERRIES and ALMONDS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h4" title="Link target outside of Sample">MICROWAVE SCRAMBLED EGGS with SMOKED SALMON</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h5" title="Link target outside of Sample">AVOCADO TOAST</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h6" title="Link target outside of Sample">TRAIL MIX with CHOCOLATE - COVERED EDAMAME</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h7" title="Link target outside of Sample">POTATO FRITTATA</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h8" title="Link target outside of Sample">HARVEST GRAINS BLEND with SPINACH</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h9" title="Link target outside of Sample">SALMON BURGERS with TZATZIKI</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h10" title="Link target outside of Sample">WARMED CHICKEN SALAD with GREEN TEA</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h11" title="Link target outside of Sample">ROASTED CHICKEN with LEEKS and APPLES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c09_r1#h12" title="Link target outside of Sample">LENTILS with CHICKEN SAUSAGE</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/andr_9781569759516_oeb_c10_r1" title="Link target outside of Sample">CHAPTER 10 - SPECIAL OCCASIONS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c10_r1#h1" title="Link target outside of Sample">EGGPLANT PARMESAN LASAGNE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c10_r1#h2" title="Link target outside of Sample">CRAB CAKES BENEDICT</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c10_r1#h3" title="Link target outside of Sample">SALMON with MIREPOIX</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c10_r1#h4" title="Link target outside of Sample">LEMON PASTA with CLAMS and CHIVES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c10_r1#h5" title="Link target outside of Sample">LOBSTER SAUCE with LANGOUSTINE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c10_r1#h6" title="Link target outside of Sample">ISRAELI COUSCOUS with LEMON SHRIMP</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c10_r1#h7" title="Link target outside of Sample">RAVIOLI with BROWN BUTTER SAUCE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c10_r1#h8" title="Link target outside of Sample">CHICKEN with 40 CLOVES of GARLIC</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c10_r1#h9" title="Link target outside of Sample">WASABI-COATED CHICKEN</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/andr_9781569759516_oeb_c11_r1" title="Link target outside of Sample">CHAPTER 11 - DESSERTS &amp; DRINKS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h1" title="Link target outside of Sample">ULTIMATE BERRY MUFFINS</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h2" title="Link target outside of Sample">SUNFLOWER SEED BUTTER COOKIES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h3" title="Link target outside of Sample">MONKEY BREAD</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h4" title="Link target outside of Sample">RASPBERRY BROWNIES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h5" title="Link target outside of Sample">BANANA BREAD with PRALINES</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h6" title="Link target outside of Sample">VANILLA PUDDING CAKE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h7" title="Link target outside of Sample">GINGER ICEBOX CAKE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h8" title="Link target outside of Sample">NUTTY CARAMEL POPCORN</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h9" title="Link target outside of Sample">CHOCOLATE FONDUE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h10" title="Link target outside of Sample">DIRT DESSERT</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h11" title="Link target outside of Sample">SPIKED CHOCOLATE MILKSHAKE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h12" title="Link target outside of Sample">BOURBON STREET SHAKE</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h13" title="Link target outside of Sample">MICHELADA</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h14" title="Link target outside of Sample">LOVE DRUNK PUNCH</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h15" title="Link target outside of Sample">SANGRIA</span>
</div>
<div class="ch1">
<span href="#/Text/andr_9781569759516_oeb_c11_r1#h16" title="Link target outside of Sample">GINGER BEER LEMONADE</span>
</div>
<div>
     <br/>
</div>
<div class="cbmh">
<span href="#/Text/andr_9781569759516_oeb_bm1_r1" title="Link target outside of Sample">TIPS &amp; TECHNIQUE</span>
</div>
<div class="cbmh">
<span href="#/Text/andr_9781569759516_oeb_in1_r1" title="Link target outside of Sample">RECIPE INDEX</span>
</div>
<div class="cbmh">
<span href="#/Text/andr_9781569759516_oeb_ata_r1" title="Link target outside of Sample">ABOUT THE AUTHOR</span>
</div>
<div class="cbmh">
<span href="#/Text/andr_9781569759516_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span>
</div>
<div>
     <br/>
</div>
<div class="crt">
    NOTE TO READERS: TRADER JOE’S<sup>®</sup> is a registered trademark of Trader Joe’s<sup>®</sup> Company and is used here for informational purposes only. This book is independently authored and published and is not affiliated or associated with Trader Joe’s<sup>®</sup> Company in any way. Trader Joe's<sup>®</sup> Company does not authorize, sponsor or endorse this book or any of the information contained herein.
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// andr_9781569759516_oeb_toc_r1.vue?15b0f775